import { useState } from "react";
import { useAvtovazRequisites } from "~/entity/AvtovazRequisites";
import { RequisiteIProps } from "~/entity/AvtovazRequisites/model/schema";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useAddNewRequisites = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { createAvtovazRequisite } = useAvtovazRequisites();

  const mutate = async (data: RequisiteIProps, options?: MutateOptions) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);

    try {
      const result = await createAvtovazRequisite(data);
      if (result.data) {
        setData(result.data);
        setIsSuccess(true);
        options?.onSuccess?.(result.data);
      } else {
        setError("Ошибка добавления реквизитов");
        options?.onError?.("Ошибка добавления реквизитов");
      }
    } catch (error) {
      setError("Ошибка добавления реквизитов");
      options?.onError?.("Ошибка добавления реквизитов");
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, mutate, isSuccess, data };
};
